<template>
  <div class="main_center">
    <div class="content">

      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-col :span="7">
            <el-form-item label="年份：" style="margin-bottom: 10px">
              <el-select v-model="form.year" value-key="value" style="width:100%;"  @change="yearsChange">
                <el-option v-for="(item,index) in yearsList"
                           :key="index"
                           :label="item"
                           :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="编号：">
              <el-input v-model="form.bidCode" clearable @keydown.enter.native.stop="getDataList"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1" v-if="moreSearchItem">
            <el-form-item label="名称：">
              <el-input v-model="form.bidName" clearable @keydown.enter.native.stop="getDataList"></el-input>
            </el-form-item>
          </el-col>
         <el-col :span="7" v-if="moreSearchItem" >
            <el-form-item label="申请单位：">
              <el-input v-model="form.questName" clearable @keydown.enter.native.stop="getDataList"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1" v-if="moreSearchItem">
            <el-form-item label="状态：" props="historyid">
              <el-select @change="searchBtn" clearable style="width: 100%" v-model="form.historyid" value-key="value">
                <el-option label="全部" value="-99"></el-option>
                <el-option label="受理中" value="-1"></el-option>
                <el-option label="已出证" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <div style="float:right;">
            <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true"
                                   icon="el-icon-arrow-down">展开
            </el-button>
            <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false"
                       icon="el-icon-arrow-up">收起
            </el-button>
            <el-button @click="searchBtn" size="small" type="primary">搜索</el-button>
            <el-button @click="refresh" plain size="small" type="primary">重置</el-button>
          </div>
        </el-row>
      </el-form>
      <div style="position: relative;top:-10px">
        <el-button size="small" icon="el-icon-delete" type="primary" v-if="hasBtnPermission('btn_jz_wintessdataAccept_del')"
                   @click="deleteSelectItem()">删除
        </el-button>
      </div>
      <el-table :data="tableData"
                ref="multipleTable"
                :height="tableMaxHeight"
                v-loading="dataListLoading"
                stripe
                border
                @selection-change="handleSelectionChange">
        <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"></el-table-column>
        <el-table-column fixed type="selection" v-if="hasBtnPermission('btn_jz_wintessdataAccept_del')" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column fixed label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" :title="scope.row.state == '0'?'办理':'查看'"
                       @click="router(scope.row)">{{scope.row.state == 0?'办理':'查看'}}</el-button>
            <el-button type="text" title="删除"
                       v-if="hasBtnPermission('btn_jz_wintessdataAccept_del')"
                       @click="deleteById(scope.row)">删除</el-button>
          </template>
        </el-table-column>


        <el-table-column label="招标项目（标段）名称" prop='bidName' header-align="center" align="left" min-width='180'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="招标项目（标段）编号" prop='bidCode' header-align="center" align="center" min-width='180'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="申请单位" prop='cateoutQuest.questName' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="申请单位角色" prop='cateoutQuest.questRole' header-align="center" align="center"
                         min-width='120'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="状态" prop='cateoutQuest.historyid' header-align="center" align="center" min-width='80'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag size="small"
                    :hit="false"
                    :type="scope.row.cateoutQuest.historyid==0?'success':''"
                    effect="plain"  >
              {{scope.row.cateoutQuest.historyid==0?"已出证":"受理中"}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="申请时间"
                         prop='cateoutQuest.questTime'
                         header-align="center"
                         align="center"
                         min-width='160'
                         :show-overflow-tooltip='true'> </el-table-column>
        <el-table-column label="出证时间"
                         prop='cateoutQuest.processinstanceEndDate'
                         header-align="center"
                         align="center"
                         min-width='160'
                         :show-overflow-tooltip='true'> </el-table-column>
      </el-table>
      <el-pagination background
                     layout="total, sizes, prev, pager, next"
                     :page-sizes="[pageSize, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle">
      </el-pagination>

    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";
  import {nearSixYearsList} from '@/utils/index';

  export default {
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 265,
      dataListLoading: false,
      yearsList:[],
      form: {
        year:new Date().getFullYear(),
        bidName:'',
        bidCode:'',
        historyid: '-99',
        questName: '',
      },
      moreSearchItem: false,
      checkList1: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      multipleSelection: [],
      user: '', //角色类型
      formData: {},
      stateslist: [],

    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
  activated() {
    //this.user = this.stateData.pageRoleIds //角色类型
    // this.refresh();
    this.yearsList = nearSixYearsList(this.form.year)
    this.getDataList()


  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    ifmove() {
      let hasBtnPermisson = this.hasBtnPermission("btn_archchg_del");
      let tableMaxHeight = document.documentElement.clientHeight - 265 +  (hasBtnPermisson ? 0 : 33);
      this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })

      // this.getDataList()
    },


    getDataList() { // 获取列表数据
      this.dataListLoading=true;
      this.$httpReq.post('/cateQuestBase/acceptList', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'searchKey': '',
        'filter':// this.form
            {
              year:this.form.year,
              bidName:this.form.bidName,
              bidCode:this.form.bidCode,
              questName:this.form.questName,
              historyid: this.form.historyid == "-99" ? "" : this.form.historyid,
            }
      }).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
        this.dataListLoading=false;
      })
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    yearsChange(val){
      this.yearsList = nearSixYearsList(val)
      this.getDataList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    searchBtn() { //搜索按钮
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList()
    },
    refresh() {//刷新按钮
      this.pageIndex = 1;
      this.form.search = "";
      this.form.questName = "";
      this.form.bidName = "";
      this.form.bidCode = "";
      this.form.historyid = '-99',
          this.getDataList()

    },


    router(item) { // 跳转详情
      var id = item.id;
      window.sessionStorage.setItem("id", id);
      window.sessionStorage.setItem("addUpdateIndex", 1)

      if (item.state==0){   //该数据为受理中状态，则跳到制作见证书页面生成pdf并可提交流程
        this.$router.push({
          name: 'cateout_quest_detail',
          query:{
            id:id
          }
        });
      }else{    //该数据为已出证状态，则跳到出证查看表单页面可下载生成的pdf
        this.$router.push({
          name: 'download_catequest_note',
          query:{
            id:id
          }
        });
      }



    },


    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // FIXME 接口待对接
        this.$httpReq.post('/cateOutQuest/delete', {
          id: item.cateoutQuest.id
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      })
    },
    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.cateoutQuest.id)
      })

      if (ids != "" || ids.length > 0) {
        // FIXME 接口待对接
        this.$httpReq.post('/cateOutQuest/delete', {
          idList: ids
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }

    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },


  }


}
</script>

<style lang="scss" scoped>
.main_center {
  .top {
    .input_title {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.margin-hide {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>